package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.ConflictMetadataDto
import com.evoapps.evoshift.domain.model.ConflictMetadata
import com.evoapps.evoshift.domain.model.ConflictType

class ConflictMetadataMapper {

    fun toDomain(dto: ConflictMetadataDto): ConflictMetadata {
        return ConflictMetadata(
            isForced = dto.isForced,
            conflictType = try {
                ConflictType.valueOf(dto.conflictStatus)
            } catch (e: Exception) {
                ConflictType.DOUBLE_BOOKED // Fallback
            },
            conflictingShiftId = dto.conflictingShiftId
        )
    }

    fun toDto(domain: ConflictMetadata): ConflictMetadataDto {
        return ConflictMetadataDto(
            isForced = domain.isForced,
            conflictStatus = domain.conflictType.name,
            conflictingShiftId = domain.conflictingShiftId
        )
    }
}
